/**
 * Footer accordion — mobile only.
 *
 * Collapses every .footer__show-menu on mobile and toggles it
 * when its preceding .footer__headline is clicked.
 * CSS (in _layout.scss) does the actual show/hide via max-height.
 */
export function initFooterAccordion() {
    var mq = window.matchMedia('(max-width: 768px)');

    function getMenu(headline) {
        var el = headline.nextElementSibling;
        while (el) {
            if (el.classList.contains('footer__show-menu')) return el;
            el = el.nextElementSibling;
        }
        return null;
    }

    function onHeadlineClick() {
        var open = this.classList.toggle('is-open');
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
        var menu = getMenu(this);
        if (menu) menu.classList.toggle('is-open', open);
    }

    function onHeadlineKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
        }
    }

    function setup(isMobile) {
        document.querySelectorAll('.footer__headline').forEach(function (headline) {
            if (isMobile) {
                headline.setAttribute('role', 'button');
                if (headline.tagName !== 'BUTTON') headline.setAttribute('tabindex', '0');
                headline.setAttribute('aria-expanded', headline.classList.contains('is-open') ? 'true' : 'false');

                if (!headline._footerAccordionBound) {
                    headline._footerAccordionBound = true;
                    headline.addEventListener('click', onHeadlineClick);
                    headline.addEventListener('keydown', onHeadlineKeydown);
                }
            } else {
                headline.removeAttribute('role');
                headline.removeAttribute('tabindex');
                headline.removeAttribute('aria-expanded');
                headline.classList.remove('is-open');
                var menu = getMenu(headline);
                if (menu) menu.classList.remove('is-open');
            }
        });
    }

    setup(mq.matches);
    mq.addEventListener('change', function (e) { setup(e.matches); });
}
